module.exports = __webpack_public_path__ + "img/phone.c741a318.svg";